import React, { useEffect, useState } from 'react';
import OrderProductList from './OrderProductList';
import OrderProductSummary from './OrderProductSummary';
import OrderQuantityEntry from '../../components/orders/orderQuantityEntry/OrderQuantityEntry';
import OrderPrint from '../../components/orders/OrderPrint';
import DeleteModal from "../../components/common/DeleteModal";
import { CreateEntry, DeleteEntry, UpdateEntry } from "../../providers/dataProvider";


const OrderProduct = ({ menuRights, values, currencyDetail, setValues, currencyList, setQuotUserEntry, quotUserEntry, handleSubmit, loading, orderProductTab,
    setOrderProductTab, activeMainTab
}) => {
    const [orderProductCount, setOrderProductCount] = useState(0);
    const [rename, setRename] = useState(null);
    const [renameError, setRenameError] = useState(null);
    const [deleteShow, setDeleteShow] = useState({ show: false, item: "", title: "", textCode: "", text: "", loading: false });
    const [actionMsg, setActionMsg] = useState(null);

    const EditOrderQuantity = (item) => {
        setOrderProductTab({ tab: "editorderquantity", data: item });
    };

    const getOrderProductId = (item) => item?.orderProductId ?? item?.id;

    const updateProducts = (updater) => {
        setValues((prev) => ({
            ...prev,
            products: updater(prev?.products || []),
        }));
    };

    const ProductRename = (item) => {
        if (!getOrderProductId(item)) return;
        setRename({ ...item });
        setRenameError(null);
    };

    const updateMarkName = () => {
        if (!rename) return;
        const markName = rename?.markName?.trim();
        if (!markName) {
            setRenameError("Name is required");
            return;
        }

        const orderProductId = getOrderProductId(rename);
        const updatedProduct = { ...rename, id: orderProductId, markName };
        setRenameError(null);
        updateProducts((products) =>
            products.map((product) => getOrderProductId(product) === orderProductId ? { ...product, markName } : product)
        );
        UpdateEntry(
            "updateorderproductmark",
            updatedProduct,
            setActionMsg,
            "Mark Name updated successfully",
            "Failed to update markName"
        );
        setRename(null);
    };

    const HandleRenameKeyDown = (event) => {
        if (event.key === "Enter") updateMarkName();
    };



    useEffect(() => {
        if (actionMsg?.message === "Mark duplicated successfully" && actionMsg?.successData?.id) {
            const duplicateId = actionMsg.successData.id;
            updateProducts((products) =>
                products.map((product, index) =>
                    typeof product?.id === "string" && product.id.indexOf("copy-") === 0 && index === products.length - 1
                        ? { ...actionMsg.successData, id: duplicateId }
                        : product
                )
            );
        }
    }, [actionMsg]);

    return (
        <div
            className={`tab-pane fade${activeMainTab === "order-summary" ? " show active" : ""}`}
            id="pills-order-summary"
            role="tabpanel"
            aria-labelledby="pills-order-summary-tab"
        >
            {orderProductTab.tab === "editorderquantity" ? (
                <OrderQuantityEntry
                    setOrderProductTab={setOrderProductTab}
                    values={values}
                    setValues={setValues}
                    orderProductTab={orderProductTab}
                    currencyDetail={currencyDetail}
                />
            ) : (
                <>
                    <div className="row pt-1 product-configurations-row mt-2 order-product-manage">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="quote-product-actionbar order-product-actionbar">
                                <div>
                                    <span>Products</span>
                                    <strong>{orderProductCount} mark{orderProductCount === 1 ? "" : "s"}</strong>
                                </div>
                                <div className="quote-product-actionbar-actions">
                                    {/* {menuRights?.canPrint === true && (
                                        <OrderPrint values={values} currencyDetail={currencyDetail} />
                                    )} */}
                                    <button
                                        className="btn save-btn"
                                        type="button"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                    >
                                        {!values?.id ? "Save" : "Update"}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="row quotation-summary-row order-summary-products-row">
                                <OrderProductList
                                    values={values}
                                    currencyDetail={currencyDetail}
                                    EditOrderQuantity={EditOrderQuantity}
                                    rename={rename}
                                    renameError={renameError}
                                    setOrderProductCount={setOrderProductCount}
                                    onRename={ProductRename}
                                    onRenameBlur={updateMarkName}
                                    onRenameChange={setRename}
                                    onRenameKeyDown={HandleRenameKeyDown}
                                />
                                <OrderProductSummary
                                    values={values}
                                    setValues={setValues}
                                    currencyDetail={currencyDetail}
                                    setQuotUserEntry={setQuotUserEntry}
                                    quotUserEntry={quotUserEntry}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
export default OrderProduct;
